import client from '../../base-api';

const serviceURL = '/unemployed/case-management-coaching';

const caseManagementCoachingService = {
    getCaseManagementCoachingList(unemployedId: number) {
        return client.get(`${serviceURL}/${unemployedId}`);
    },
    getCaseManagementCoaching(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },
    postCaseManagementCoaching(coachingData: any) {
        return client.post(`${serviceURL}`, coachingData);
    },
    putCaseManagementCoaching(coachingData: any, coachingId: number) {
        return client.put(`${serviceURL}/${coachingId}`, coachingData);
    },
    deleteCaseManagementCoaching(coachingId: number) {
        return client.delete(`${serviceURL}/delete/${coachingId}`);
    },
}

export default caseManagementCoachingService;